import { Component, Fragment } from "react";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";

const infosubtitle = "Get in touch with us";
const infotitle = "We're Always Eager To Hear From You!";
const contacttitle =
  "Fill The Form Below So We Can Get To Know You And Your Needs Better.";

let infoListContent = [
  {
    imgUrl: "assets/images/contact/icon/01.png",
    imgAlt: "Contact Info Thumb",
    title: "Office Address",
    desc: "1201 park street, Fifth Avenue",
  },
  {
    imgUrl: "assets/images/contact/icon/02.png",
    imgAlt: "Contact Info Thumb",
    title: "Phone number",
    desc: "+22698 745 632, 02 982 745",
  },
  {
    imgUrl: "assets/images/contact/icon/03.png",
    imgAlt: "Contact Info Thumb",
    title: "Send Us an Email",
    desc: "yourmail@gmail.com",
  },
];

const isMobile = window.innerWidth <= 768;

class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactName: "",
      contactEmail: "",
      contactSubject: "",
      contactMassage: "",
    };
  }

  render() {
    return (
      <Fragment>
        <Header />
        <div className="padding-top contact-section">

        {/* ================= INFO SECTION ================= */}
        <div className="section-header info-section padding-top padding-bottom">
          <div className="info-glow-layer"></div>

          <div className="container">
            <p className="text-anim-fade-down js-animate delay-sm">
              {infosubtitle}
            </p>

            <h2
              className={`text-anim-typing delay-md ${
                !isMobile ? "js-animate" : ""
              }`}
            >
              {infotitle}
            </h2>


            <div className="section-wrapper">
              <div className="row justify-content-center g-4">
                {infoListContent.map((val, i) => (
                  <div className="col-lg-4 col-sm-6 col-12" key={i}>
                    <div className="contact-item text-center">
                      <div className="mb-4">
                        <img src={val.imgUrl} alt={val.imgAlt} />
                      </div>
                      <div className="contact-content">
                        <h6 className="title">{val.title}</h6>
                        <p>{val.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ================= CONTACT FORM ================= */}
        <div className="contact-section">
          <div
            className="contact-top padding-top padding-bottom bg-attachment"
            style={{
              backgroundImage: "url(/assets/images/video/bg-contact.svg)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              minHeight: "100vh",
            }}
          >
            <div className="contact-overlay"></div>

            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-lg-9">
                  <div className="contact-form-wrapper text-center">
                    <div className="esports-frame"></div>

                    <h2 className="mb-5">{contacttitle}</h2>

                    <form className="contact-form">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Your Name *"
                          value={this.state.contactName}
                          onChange={(e) =>
                            this.setState({ contactName: e.target.value })
                          }
                        />
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Your Email *"
                          value={this.state.contactEmail}
                          onChange={(e) =>
                            this.setState({ contactEmail: e.target.value })
                          }
                        />
                      </div>

                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Your Subject *"
                          value={this.state.contactSubject}
                          onChange={(e) =>
                            this.setState({ contactSubject: e.target.value })
                          }
                        />
                      </div>

                      <div className="form-group w-100">
                        <textarea
                          rows="8"
                          placeholder="Your Message"
                          value={this.state.contactMassage}
                          onChange={(e) =>
                            this.setState({ contactMassage: e.target.value })
                          }
                        ></textarea>
                      </div>

                      <div className="form-group w-100 text-center">
                        <button className="default-button" type="submit">
                          <span>Send Our Message</span>
                        </button>
                      </div>
                    </form>

                    <p className="form-message"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>

        <Footer />
      </Fragment>
    );
  }
}

export default ContactUs;
